// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GH3sfzkB9DbIEpyRA6fN {\n  color: #0068ff;\n  font-weight: bold;\n  border-bottom: 1.5px dashed #0068ff;\n  display: inline;\n  cursor: pointer;\n}\n", "",{"version":3,"sources":["webpack://./src/App/components/UnderscoreLink/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;EACf,eAAe;AACjB","sourcesContent":[":local(.underscore) {\n  color: #0068ff;\n  font-weight: bold;\n  border-bottom: 1.5px dashed #0068ff;\n  display: inline;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"underscore": "GH3sfzkB9DbIEpyRA6fN"
};
export default ___CSS_LOADER_EXPORT___;
